import { Box } from '@mui/material';
import { FC } from 'react';
import BaseCopyableText from '../ui/BaseCopyableText';

type TableCellBulletListProps = {
    list: string[];
};

const TableCellBulletList: FC<TableCellBulletListProps> = ({ list }) => {
    if (!list.length) return <>-</>;

    return (
        <Box sx={{ display: 'grid', gap: 0.5, py: 0.5, width: '100%' }}>
            {list.map((item, index) => {
                return (
                    <Box key={`${item}-${index}`} sx={{ display: 'flex', gap: 1, minWidth: 0 }}>
                        {list.length > 1 && (
                            <Box component="span" sx={{ flexShrink: 0, fontSize: 12 }}>
                                •
                            </Box>
                        )}
                        <BaseCopyableText value={item} />
                    </Box>
                );
            })}
        </Box>
    );
};

export default TableCellBulletList;
